import * as $ from "jquery";
import _ from "underscore";
import downloadHelper from './download-helper';

// store our data from the jsonp callback

export default class Download {
  $domRoot: JQuery<any>;
  params: any;
  data: any;
  dropdown: any;
  downloadLink: any;
  currentVersion: any;
  releaseNotes: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = { ...params };
    this.data;
    this.dropdown;
    this.downloadLink;
    this.init();
  }

  init() {
    // orgainize structured data by os
    this.params.downloadInfo = _.groupBy(this.params.downloadInfo, "os");
    this.getJSON();
  }

  // get JSONP and call retrieveData(data) when response is a 200
  async getJSON() {
    const newData = await fetch(this.params.productJSON,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      })
      .then((res) => res.json())
      .catch();
    if (newData) {
      newData.forEach((item: any) => {
        item.platform = item.downloadLabels.map((label: any) => label.labelName).toString();
        item.description = item.name;
        item.zipUrl = item.zipURL.replace("http:", "https:");
      });
      this.data = newData;
      downloadHelper.retrieveData(
        this.data,
        this.initialEvents,
        this,
        this.params.pageType
      );
      $(".aui-icon.loading").hide();
    }
  }

  // Load the underscore template in the .FTL
  getTemplate(name: string) {
    switch (name) {
      case "download":
        var template = _.template($("#download-template").html());
        $("#download-view").html(
          template({
            downloads: this.data,
            os: downloadHelper.getOS(),
            productName: this.params.product,
            showVersion: this.params.showVersion,
          })
        );
        break;
      default:
        return false;
    }
    // once template is loaded, grab the select element and to download button and store them
    this.dropdown = this.$domRoot.find("#select-product-version");
    this.downloadLink = this.$domRoot.find("#downloads-button");
    this.currentVersion = this.$domRoot.find("#current-version");
    this.releaseNotes = this.$domRoot.find("#release-notes");
  }

  // this is called in the getJSON() callback -- retrieveData(data, callback, context, type). Context is "this"
  initialEvents(context) {
    context.getTemplate("download");
    downloadHelper.changeDownload(
      context.dropdown,
      context.downloadLink,
      context.currentVersion,
      context.releaseNotes
    );
    downloadHelper.download(context.$domRoot, context.downloadLink);
    context.dropdown.trigger("change");
  }
}
